import { createFileRoute, useSearch } from '@tanstack/react-router';
import { useCallback } from 'react';
import {
  ContainerSelectionArgs,
  ContainerTypeLegacy,
  navigateTo,
  UpdateBargeFormGql,
} from '@amber-ui/core';

function BargeSettingsRoute() {
  // Read barge and acct from URL search params (source of truth)
  const { barge, acct } = useSearch({ strict: false }) as { barge?: string; acct?: string };
  const barge_id = barge || null;

  const onSelectContainer = useCallback((selected: ContainerSelectionArgs) => {
    if (selected.container_type === ContainerTypeLegacy.bin) {
      navigateTo('/grain_bin/dashboard', selected);
    } else if (selected.container_type === ContainerTypeLegacy.barge) {
      navigateTo('/barge/dashboard', selected);
    } else if (selected.container_type === ContainerTypeLegacy.pile) {
      navigateTo('/pile/dashboard', selected);
    }
  }, []);

  const onArchiveClick = useCallback((selected: ContainerSelectionArgs) => {
    navigateTo('/user/settings', selected);
  }, []);

  const goOrgSettings = useCallback(() => {
    navigateTo('/user/settings');
  }, []);

  if (!barge_id || !acct) return null;

  return (
    <UpdateBargeFormGql
      barge_id={barge_id}
      account_id={acct}
      url_base="/barge"
      onSelectContainer={onSelectContainer}
      onArchiveClick={onArchiveClick}
      goOrgSettings={goOrgSettings}
    />
  );
}

export const Route = createFileRoute('/_auth/_barge/barge/settings')({
  component: BargeSettingsRoute,
});
